import React, { Component } from 'react';
import { connect } from 'react-redux';

import CtaButton from '../cta-button';

import './styles.less';

const CtaModal = class extends Component {
  state = {
    background_color_err: false,
    text_color_err: false,
    border_radius_err: false,
    url_err: false,
    in_preview: false,
  };

  render = () => {
    const { ctaModalShow, currentUserIsOwner } = this.props;

    if (!ctaModalShow) {
      return null;
    }

    if (!currentUserIsOwner) {
      return null;
    }

    return (
      <div className="video-cta-modal-new in-preview">
        <CtaButton />
      </div>
    );
  };
};

const mapStateToProps = state => {
  const { current_user_is_owner: currentUserIsOwner } = state.share_video;
  const { cta_flow: ctaModalShow } = state.editor;

  return {
    ctaModalShow,
    currentUserIsOwner,
  };
};

export default connect(mapStateToProps, null)(CtaModal);
